import { render, staticRenderFns } from "./ListBanner.vue?vue&type=template&id=ca162230&"
import script from "./ListBanner.vue?vue&type=script&lang=js&"
export * from "./ListBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports